import script from "./UpdateBaseBusinessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateBaseBusinessModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateBaseBusinessModal.vue?vue&type=style&index=0&id=4bcf98e7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcf98e7"]])

export default __exports__